import { getAbsoluteApiUrl } from "@dashboard/config";
import { stringifyQs } from "@dashboard/utils/urls";

export const importSection = "/import/";
export const importOverviewPath = importSection;
export const importOverviewUrl = (params?: Record<string, string>) =>
  importSection + (params ? "?" + stringifyQs(params) : "");

/**
 * Returns the absolute URL for a template download, e.g.
 * http://localhost:8000/import-template/CATEGORIES/
 *
 * We derive the backend origin from the GraphQL API URL
 * (e.g. http://localhost:8000/graphql/) and append the REST path.
 */
export const IMPORT_TEMPLATE_URL = (importType: string): string => {
  try {
    const apiUrl = getAbsoluteApiUrl();
    const origin = new URL(apiUrl).origin;

    return `${origin}/import-template/${importType}/`;
  } catch {
    return `/import-template/${importType}/`;
  }
};

/**
 * Returns the URL for the image folder scan endpoint.
 * Scans MEDIA_ROOT/import/, classifies each image as shared or
 * variant-specific, and returns a pre-filled images XLSX.
 */
export const IMPORT_SCAN_IMAGES_URL = (): string => {
  try {
    const apiUrl = getAbsoluteApiUrl();
    const origin = new URL(apiUrl).origin;

    return `${origin}/import-scan-images/`;
  } catch {
    return `/import-scan-images/`;
  }
};
